import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import { useTranslation } from "react-i18next";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { AgGridReact } from "ag-grid-react";
import { ClientSideRowModelModule } from "ag-grid-community"; // Import required module
import { ModuleRegistry } from "ag-grid-community"; // Registry for modules
//import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
//import "ag-grid-community/styles/ag-theme-alpine.css"; // Theme CSS
import "../../../style/style-ag-grid.css";
// import ModalFormInstalacion from "../../../components/form-instalacion";
// import { createInstalacion, disableInstalacion, } from "../../../api/api-instalacion";
// import ModalFormDesinstalacion from "../../../components/form-desinstalar";
import { createClienteSecundario, deleteClienteSecundario, obtenerClienteSecundario } from "../../../api/api-cliente-secundario";
import ModalClienteSecundario from "../../../components/form-cliente-secundario";
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";

// Register the modules
ModuleRegistry.registerModules([ClientSideRowModelModule]);

let accesoBotonNuevo = '';


export default function ListClienteSecundario() {

  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [showModalClienteSecundario, setShowModalClienteSecundario] = useState(false);
  const [formData, setFormData] = useState({});
  const [rowData, setRowData] = useState([]);
  const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
  const [isHovered, setIsHovered] = useState(false);
  const hoverColor = COLOR_AZUL_MAIN;

  const columnDefs = [
    {
      field: "acciones", headerName: t("column_actions"),
      cellRenderer: (params) => {
        // console.log('cellRenderer');
        // console.log(params);
        return (
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button
              onClick={() => handleDelete(params.data)}
              style={{
                backgroundColor: "#DC3545",
                color: "white",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              {t("label_delete")}
            </button>
          </div>
        );
      }
    },
    { field: "idactivo", headerName: "ID ACTIVO", },
    { field: "idempresaplataforma", headerName: 'ID EMPRESA', hide: true, filter: true, sortable: true, },
    { field: "empresaplataforma", headerName: t("column_company"), filter: true, sortable: true, },
    { field: "principal", headerName: 'PRINCIPAL', filter: true, sortable: true, },
    { field: "verenrastreo", headerName: 'VER EN RASTREO', filter: true, sortable: true, },
  ];

  useEffect(() => {
    const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
    if (mainColor !== null) {
      setPrimaryColor(mainColor);
    }
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      /*let obj = {};
      obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      let permiso = null;
      let lista = [];

      lista = await obtenerClienteSecundario(objEnviar);
      // console.log('lista');
      // console.log(lista);
      agregarAccionesALista(lista, permiso);
      setTieneAccesoAlModulo(true);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const agregarAccionesALista = (lista, permiso) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);
      setRowData(lista);
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const onConfirmClienteSecundario = async (formData) => {
    try {
      // console.log('onConfirmFormCreate');
      // console.log(formData);
      setShowModalClienteSecundario(false);
      // return;

      const resp = await createClienteSecundario(formData);
      if (resp.error === false) {
        alert(t("alert_created_success"));
        reset();
      }
      if (resp.error === true) {
        alert(resp.message);
        return;
      }


    } catch (err) {
      console.log('onConfirmForm err');
      console.log(err);
    }
  };

  const handleDelete = async (params) => {
    try {
      // console.log('handleDelete', params);
      const isConfirmed = window.confirm("Are you sure you want to delete this item? " + params.idactivo + " -> " + params.empresaplataforma);
      if (isConfirmed) {
        // alert("Item deleted!");
        let objEnviar = {};
        objEnviar.idActivo = params.idactivo;
        objEnviar.idEmpresaPlataforma = params.idempresaplataforma;
        const resp = await deleteClienteSecundario(objEnviar);
        if (resp.error === false) {
          alert(t("alert_created_success"));
          reset();
        }
        if (resp.error === true) {
          alert(resp.message);
          return;
        }
      } else {
        alert("Action canceled!");
      }
    } catch (err) {
      console.log('handleDelete err');
      console.log(err);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="pt-4 px-4">
          <div className="flex justify-between">
            <label
              style={{
                fontWeight: 'bold',
              }}
            >
              {t("title_manage_cliente_secundario")}
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  setFormData({
                    ...formData,
                    id: 0,
                    idGrupo: null,
                    idSubGrupo: null,
                    idActivo: null,
                    idEmpresaPlataformaOrigen: null,
                    idEmpresaPlataformaDestino: null,
                  });
                  setShowModalClienteSecundario(true);
                }}
                style={{
                  display: accesoBotonNuevo,
                }}
              >
                {t("label_new")}
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={(handleAtrasClick)}
              >
                {t("label_back")}
              </button>
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button> */}
            </div>
          </div>
          <div className="flex justify-between gap-4">

            {/* Button (3/12 columns) */}
            <div className="w-full md:w-6/12 lg:w-3/12 xl:w-3/12 flex items-end">
              <button
                type="button"
                className={`${ESTILO_BOTON_MODAL_ACEPTAR} w-full`}
                style={{
                  backgroundColor: isHovered ? hoverColor : primaryColor,
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => reset()}
              >
                {t("label_update")}
              </button>
            </div>
          </div>
          <div
            className="ag-theme-alpine pt-4"
            style={{
              height: "512px",
              width: "100%",
              "--ag-header-background-color": `${primaryColor}`,
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              rowHeight={50}
            />
          </div>
          <ModalClienteSecundario
            isOpen={showModalClienteSecundario}
            onCancel={() => { setShowModalClienteSecundario(false); }}
            title={t("title_manage_cliente_secundario")}
            formData={formData}
            setFormData={setFormData}
            onConfirm={onConfirmClienteSecundario}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarTipoCombustible render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
